import React, { useRef, useState } from 'react';

import TagsGraphic from './Components/Graphics/TagsGraphic';
import FilterData from '../../../../components/FilterAnalyze/FilterData/FilterData';

const Tags = ({ parentFilter, onClickFilter }) => {
  const [refGraphic, setRefGraphic] = useState(useRef(null));

  const getChildRefGraphic = (ref) => {
    setRefGraphic(ref);
  };

  return (
    <div>
      <FilterData
        onClickFilter={onClickFilter}
        graphicReference={refGraphic}
        graphicName="grafico-tags"
        showDownload
        showMoreFilters
        isTagGraphic
      />
      <TagsGraphic
        componentData={{ parentFilter }}
        getRefGraphic={getChildRefGraphic}
      />
    </div>
  );
};

export default Tags;
